module.exports = __webpack_public_path__ + "static/albums-logo-9c7f7c6f95371de0a28b52c513776427.png";